export const productivity = {
  // Dashboard
  productivityCenter: 'Productivity Center',
  productivityCenterDescription: 'Your command center for goals, habits, tasks, and reminders',
  loadingProductivityData: 'Loading productivity data...',
  
  // Tabs
  overview: 'Overview',
  management: 'Management',
  ai: 'AI',
  projects: 'Projects',
  advanced: 'Advanced',
  calendar: 'Calendar',
  analytics: 'Analytics',  
  activity: 'Activity',
  
  // Overview
  todayMetrics: "Today's Metrics",
  quickInsights: 'Quick Insights',
  metricsUnavailable: 'Metrics unavailable',
  noMetricsData: 'No metrics data available',
  recentActivity: 'Recent Activity',
  viewAllActivity: 'View all activity',
  noRecentActivity: 'No recent activity',
  noActivitiesFound: 'No activities found',
  
  // Quick Actions
  quickActions: 'Quick Actions',
  createGoal: 'Create Goal',
  addTask: 'Add Task',
  trackHabit: 'Track Habit',
  setReminder: 'Set Reminder',
  
  // Quick Actions - Categories
  create: 'Create',
  review: 'Review', 
  analyze: 'Analyze',
  
  // Quick Actions - Items
  newGoal: 'New Goal',
  setNewObjective: 'Set a new objective',
  newHabit: 'New Habit',
  startHealthyHabit: 'Start a healthy habit',
  newTask: 'New Task',
  addDailyTask: 'Add a daily task',
  reminder: 'Reminder',
  scheduleReminder: 'Schedule a reminder',
  scheduleActivity: 'Schedule Activity',
  planNewActivity: 'Plan a new activity',
  newProject: 'New Project',
  organizeTasksInProjects: 'Organize tasks in projects',
  templates: 'Templates',
  useGoalTemplates: 'Use goal templates',
  viewProjects: 'View Projects',
  manageActiveProjects: 'Manage active projects',
  calendarView: 'Calendar',
  viewFullAgenda: 'View your complete agenda',
  analyticsView: 'Analytics',
  reviewProgress: 'Review your progress',
  
  // Navigation
  back: 'Back',
  
  // Analytics
  productivityAnalytics: 'Productivity Analytics',
  detailedAnalysis: 'Detailed analysis of your performance',
  selectPeriod: 'Select period',
  thisWeek: 'This week',
  thisMonth: 'This month',
  thisQuarter: 'This quarter',
  globalScore: 'Global Score',
  excellent: 'Excellent',
  good: 'Good',
  needsImprovement: 'Needs Improvement',
  goals: 'Goals',
  habits: 'Habits',
  tasks: 'Tasks',
  reminders: 'Reminders',
  completed: 'completed',
  completionRate: 'completion rate',
  completedToday: 'completed today',
  completionRates: 'Completion Rates',
  statusDistribution: 'Status Distribution',
  weeklyTrend: 'Weekly Trend',
  detailedBreakdown: 'Detailed Breakdown',
  pending: 'Pending',
  
  // Calendar
  noActivitiesForDate: 'No activities for this date',
  weeklyView: 'Weekly View',
  noActivities: 'No activities',
  activities: 'activities',
  more: 'more',
  
  // Activity Feed
  activityFeed: 'Activity Feed',
  allActivities: 'All your activities in one place',
  filterByType: 'Filter by type',
  all: 'All',
  goal: 'Goal',
  habit: 'Habit',  
  task: 'Task',
  reminderType: 'Reminder',
  sortBy: 'Sort by',
  mostRecent: 'Most recent',
  oldest: 'Oldest',
  dueDate: 'Due date',
  priority: 'Priority',
  
  // Days of week
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  
  // Months short
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dec',
  
  // Overview metrics
  inProgress: 'in progress',
  overdue: 'overdue',
  streak: 'Streak',
  today: 'today',
  next24h: 'next 24h',
  ok: 'ok',
  globalProgress: 'Overall Progress',
  interestingData: 'Interesting Data',
  allGood: 'All good!',
  
  // Projects
  activeProjects: 'Active Projects',
  new: 'New',
  noActiveProjects: 'No active projects',
  createFirstProject: 'Create First Project',
  progress: 'Progress',
  viewAllProjects: 'View all projects',
  
  // Templates
  goalTemplates: 'Goal Templates',
  taskTemplates: 'Task Templates',
  viewAll: 'View All',
  milestones: 'milestones',
  use: 'Use',
  daysShort: 'd',
  minutesShort: 'm',
};